import _get from 'lodash/get';

export const getCurrentVirtualEventMeetingId = state =>
  _get(state, 'publicWebsite.currentVirtualEvent.virtual_meeting.meeting_id');

export const getThemeKey = state => _get(state, 'publicWebsite.wedding.theme.key');

export const getWeddingAccountId = state => _get(state, 'publicWebsite.wedding.wedding_account_id');

export const getPublicWebsiteWedding = state => _get(state, 'publicWebsite.wedding', {});

export const getPublicWebsite = state => _get(state, 'publicWebsite', {});

export const getPublicWebsitePage = state => _get(state, 'publicWebsite.page');
